function addObject(obj: Record<string, any>, key: string, value: any, index?: number): Record<string, any> {
    const result: Record<string, any> = {};

    const keys = Object.keys(obj);
    const insertIndex = typeof index === 'number' && index >= 0 ? index : keys.length;

    for (let i = 0; i < keys.length; i++) {
        if (i === insertIndex) {
            result[key] = value;
        }

        result[keys[i]] = obj[keys[i]];
    }

    // If index is beyond the last position, insert at the end
    if (insertIndex >= keys.length) {
        result[key] = value;
    }

    return result;
}

// ----------------------------------------------------------------------------

export default addObject;
